import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InvertColorsOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"invert_colors_on"}/>
}
